import { motion } from "framer-motion";
import { Clock, AlertTriangle, MonitorSmartphone, EyeOff } from "lucide-react";

const problems = [
  {
    icon: Clock,
    title: "Stuck at your desk",
    description: "You start a 30-minute Claude Code session and can't leave until it finishes. Lunch, meetings, walks — all on hold.",
  },
  {
    icon: AlertTriangle,
    title: "Missed approval prompts",
    description: "The agent needs permission to run a command. You're not there. It waits. Your entire session stalls for hours.",
  },
  {
    icon: MonitorSmartphone,
    title: "Awkward SSH workarounds",
    description: "You try SSH-ing from your phone to check on the session. Tiny text, broken TUI, no context. It's barely usable.",
  },
  {
    icon: EyeOff,
    title: "No mobile visibility",
    description: "Did the refactor finish? Did the tests pass? There's no way to know without physically walking back to your machine.",
  },
];

export default function ProblemSection() {
  return (
    <section
      data-testid="problem-section"
      className="py-24 px-6"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-16"
        >
          <span
            className="text-xs uppercase tracking-wider mb-4 block"
            style={{
              color: "#EF4444",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "11px",
            }}
          >
            The problem
          </span>
          <h2
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-white leading-tight"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            AI coding agents can work without you.{" "}
            <span style={{ color: "#71717A" }}>
              But today, you still have to babysit them.
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px" style={{ background: "rgba(255,255,255,0.06)" }}>
          {problems.map((problem, i) => (
            <motion.div
              key={problem.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="p-8"
              style={{ background: "#0A0A0A" }}
            >
              <problem.icon
                className="w-5 h-5 mb-4"
                style={{ color: "#EF4444" }}
                strokeWidth={1.5}
              />
              <h3
                className="text-base font-medium text-white mb-2"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {problem.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: "#71717A" }}>
                {problem.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
